import aboutEn from './about.en'
import navigationsEn from './navigations.en'

module.exports = {
  messages: {
    login: 'Login',
    back: 'back',
    tab: [
      {
        title: 'Home',
        children: []
      },
      {
        title: 'About',
        // children: ['Overview', 'Leadership', 'Previous leaders', 'Administrative Staff']
        children: ['Overview', 'Leadership', 'Administrative Staff']
      },
      {
        title: 'Research Center'
      },
      {
        title: 'Faculty',
        children: ['Teacher directory', 'Outstanding talent', 'Postdoctoral']
      },
      {
        title: 'News & Events',
        children: ['News', 'Academic Activities', 'Events', 'Recruitment']
      },
      {
        title: 'Students',
        children: ['Graduate']
      },
      {
        title: 'Research',
        children: ['Centers & Labs', 'Achievements']
      },
    ],
    slogan: 'AI for unlimited future',
    newsButton: 'read more',
    messageMenu: [
      {
        title: 'News',
      },
      {
        title: 'Events',
      },
      {
        title: 'Academic Activities',
      }
    ],
    messageButton: 'read more',
    advertising: 'THE ARTIFICIAL INTELLIGENCE INSTITUTE,<br/>SHANGHAI JIAO TONG UNIVERSITY<br/>RECRUITS TALENT WORLDWIDE',
    advertisingButton: 'read more',
    scienceMessagesMore: 'To see all',
    scienceMessagesTitle: 'Research',
    scienceMessagesButton: 'learn more',
    addressTitle: 'Contact us',
    address: 'Software Building, Shanghai Jiao Tong University<br/>800 Dongchuan Road, Minhang District, Shanghai',
    phone: '021-34206041',
    email: 'AI_SJTU@sjtu.edu.cn',
    sign: 'Shanghai Jiao Tong University',
    searchTitle: 'Search',
    searchSecondTitle: 'Your keywords will be searched globally on the site',
    searchButton: 'search',
    about: aboutEn,
    navigations: navigationsEn,
    facultyNavigations: [
      {
        name: 'Teacher directory',
        nav: 'teachers'
      },
      {
        name: 'Outstanding talent',
        nav: 'talent'
      },
      {
        name: 'Postdoctoral',
        nav: 'postdoctoral'
      }
    ],
    teacherSearchText: 'Search name',
    teacherSearchOptionOne: 'Research direction',
    teacherSearchOptionTwo: 'Position',
    teacherMoreButton: 'learn more',
    teacherNull: 'No relevant information was found. Please change the filter or input again',
    postgraduateNull: 'There is no relevant mentor',
    talentOptionTitle: 'Talent category',
    postgraduateMenu: ['Supervisor Introduction', 'Cultivation Management'],
    postgraduateOptionTitle: '导师介绍',
    cultivateNavigations: [
      {
        name: 'Postgraduate cultivation',
        nav: 'postgraduate'
      },
    ],
    details: 'details',
    researchNavigations: [
      {
        name: 'Research directions',
        nav: 'directions'
      },
      {
        name: 'Research base',
        nav: 'base'
      },
      {
        name: 'Research results',
        nav: 'results'
      },
    ],
    jointBaseUnfold: 'View details',
    jointBaseShrink: 'Pack up the details',
    jointBaseButton: 'Visit the web site',
    paperTitle: [
      '序号',
      '论文题目',
      '作者'
    ],
    newsNavigations: [
      {
        name: 'Academic Activities',
        nav: 'academic'
      },

      {
        name: 'Events',
        nav: 'announcements'
      },
      {
        name: 'News',
        nav: 'news'
      },
      {
        name: 'Recruitment',
        nav: 'jobs'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/en.js